<script setup lang="ts">
defineOptions({
	name: 'WarningSection',
})

const { t: $t } = useI18n()

const warningSigns = [
	$t('Have you ever spent more money or time playing than you intended?'),
	$t('Have you ever lied to friends or family about how much you play?'),
	$t('Has playing caused you stress, anxiety, or financial problems?'),
	$t('Do you find yourself constantly thinking about playing?'),
]
</script>

<template>
	<section class="bg-neutral-50 py-10 sm:py-20">
		<div class="container space-y-11 sm:space-y-28">
			<div
				class="flex flex-col gap-10 sm:gap-8 xl:gap-12 xl:flex-row justify-between items-start max-w-[1098px] mx-auto text-center smm:text-left"
			>
				<h2 class="text-3xl sm:text-[48px] text-secondary-800 font-semibold sm:max-w-lg leading-tight sm:!leading-none">
					{{ $t('Warning signs to watch for') }}
				</h2>
				<p class="text-neutral-800 sm:text-neutral-900 text-[18px] sm:max-w-lg leading-6">
					<span class="font-bold">{{ $t('Crisis Support') }}:</span>
					{{
						$t(
							`If you're in immediate distress, please contact your local emergency services or a crisis helpline in your area`,
						)
					}}.
				</p>
			</div>

			<div class="grid grid-cols-1 smm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-16 max-w-[1098px] mx-auto">
				<div
					v-for="(sign, index) in warningSigns"
					:key="index"
					class="flex flex-col gap-4 items-center smm:items-start"
				>
					<div class="bg-primary-50 size-10 rounded-full flex items-center justify-center border-2 border-primary-500">
						<span class="text-primary-500 font-medium">{{ String(index + 1).padStart(2, '0') }}</span>
					</div>
					<p class="text-neutral-700 leading-5 min-h-16 text-center smm:text-left">{{ sign }}</p>
				</div>
			</div>
		</div>
	</section>
</template>
